import { t } from '@/i18n';
import { z } from 'zod';
import { FundAdditionalAttributesModel } from './project';

export const executionProgressType = z.enum([
  'income-and-expenditure',
  'fund-business',
]);

export const ExecutionProgressTypeLabelModifier = {
  'income-and-expenditure': t('income-and-expenditure'),
  'fund-business': t('fund-business'),
} as const satisfies Record<z.infer<typeof executionProgressType>, string>;

export const UpdateExecutionProgressIncomeAndExpenditureFormSchema =
  FundAdditionalAttributesModel.pick({
    accountingTypeIds: true,
    numberOfLocalFundBuilding: true,
  });
